import * as CL from '@design-system/component-library';
import * as React from 'react';
import { paths } from '../../../common/constants/pathVariables.js';
import { employeeOmaElisaMsg, orderRequestsMsg, t } from '../../../common/i18n';
import type { AuthServiceProps } from '../../../public/site/authService.js';
import type { NavigateFunction } from 'react-router';

const navigateOrRedirect = (navigate: NavigateFunction, url: string, isPublicSite: boolean) =>
  isPublicSite ? (window.location.href = url) : navigate(url);

export const eoeUserMenuLinks = (
  navigate: NavigateFunction,
  hasApproverRole: boolean,
  isPublicSite: boolean,
  prepareElisaIdLogin?: AuthServiceProps['prepareElisaIdLogin']
) => {
  return [
    {
      icon: <CL.Icon icon="home" />,
      onClick: (e: React.SyntheticEvent) => {
        e.preventDefault();
        navigateOrRedirect(navigate, paths.EMPLOYEE_HOME, isPublicSite);
      },
      text: t.S0FN(employeeOmaElisaMsg),
      url: paths.EMPLOYEE_HOME,
    },
    ...(hasApproverRole
      ? [
          {
            icon: <CL.Icon icon="invoice" />,
            onClick: (e: React.SyntheticEvent) => {
              e.preventDefault();
              navigateOrRedirect(navigate, paths.EMPLOYEE_PENDING_REVIEW_ORDERS, isPublicSite);
            },
            text: t.Y29L(orderRequestsMsg),
            url: paths.EMPLOYEE_PENDING_REVIEW_ORDERS,
          },
        ]
      : []),
    ...(prepareElisaIdLogin
      ? [
          {
            icon: <CL.Icon icon="arrow-left" />,
            onClick: (e: React.MouseEvent) => {
              e.preventDefault();
              prepareElisaIdLogin({ changeContext: true });
            },
            text: t.GT6R('Change your role'),
            url: '#',
          },
          {
            icon: <CL.Icon icon="arrow-left" />,
            onClick: (e: React.MouseEvent) => {
              e.preventDefault();
              prepareElisaIdLogin({ noContextClient: true });
            },
            text: t.D1GD('Add new company'),
            url: '#',
          },
        ]
      : []),
  ];
};
